import { createAsyncThunk } from '@reduxjs/toolkit';
import { FacilityTypeOptions } from '../models/facility-type-options';

export const GetFacilityTypeOptions = createAsyncThunk(
    'profilesData/getFacilityTypeOptions',
    async (profileId: string, { getState }: any) => {
        const axios = getState().core.axios;
        const response = await axios.get(
            `api/Profiles/${profileId}/facility-type-options`
        );
        return response.data as FacilityTypeOptions;
    }
);
